import React, { useState } from 'react';
// Importa a nova função de login
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';
import './Login.css';
import logoImage from '../Login-logo.jpg';

const versao = 'Versão 3.4'

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      // Usa a nova sintaxe da função de login
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Falha no login. Verifique seu e-mail e senha.");
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logoImage} alt="Logo" className="login-logo" />
        <form onSubmit={handleLogin} className="login-form">

          <h2>SISDengue Eunápolis</h2>
          <h3>Controle de Endemias</h3>
          <p>Acesso ao Sistema</p>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p>{versao}</p>
      </div>
    </div>
  );
}

export default Login;